<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_equipe">Equipe</label>
      </div>
      <select id="classement_equipe" name="classement_equipe" disabled class="custom-select">
        <option>{{ (equipe && equipe.nom) ? equipe.nom : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Matchs Joués (J)</span>
      </div>
      <input :value="classement.matchs_joues_j" id="classement_matchs_joues_j" name="classement_matchs_joues_j" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Matchs Gagnés (G)</span>
      </div>
      <input :value="classement.matchs_gagnes_g" id="classement_matchs_gagnes_g" name="classement_matchs_gagnes_g" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Matchs Perdus (P)</span>
      </div>
      <input :value="classement.matchs_perdus_p" id="classement_matchs_perdus_p" name="classement_matchs_perdus_p" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Matchs Nulles (N)</span>
      </div>
      <input :value="classement.matchs_nulles_n" id="classement_matchs_nulles_n" name="classement_matchs_nulles_n" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Buts Marqués (GP)</span>
      </div>
      <input :value="classement.buts_marques_gp" id="classement_buts_marques_gp" name="classement_buts_marques_gp" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Buts Encaissés (GC)</span>
      </div>
      <input :value="classement.buts_encaisses_gc" id="classement_buts_encaisses_gc" name="classement_buts_encaisses_gc" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Points (PTS)</span>
      </div>
      <input :value="classement.points_pts" id="classement_points_pts" name="classement_points_pts" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Différence des buts (GD)</span>
      </div>
      <input :value="classement.difference_buts_gd" id="classement_difference_buts_gd" name="classement_difference_buts_gd" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_saison">Saison</label>
      </div>
      <select id="classement_saison" name="classement_saison" disabled class="custom-select">
        <option>
          {{ (saison && saison.date_debut && saison.date_fin) ?
            (saison.annee_debut  + ' - ' + saison.annee_fin)
            : ''
          }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_championnat">Championnat</label>
      </div>
      <select id="classement_championnat" name="classement_championnat" disabled class="custom-select">
        <option>{{ (championnat && championnat.nom) ? championnat.nom : '' }}</option>
</select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_position">Position</label>
      </div>
      <input :value="classement.position" id="classement_position" name="classement_position" disabled type="text" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="classement.date_creation"
             name="classement_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="classement.temps_creation"
             name="classement_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="classement.date_modification"
             name="classement_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="classement.temps_modification"
             name="classement_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    classement: {
      type: Object
    }
  },
  data(){
    return{
      equipe: null,
      saison: null,
      championnat: null,
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetOneData({
        table: "equipes",
        table_id: this.classement.equipe_id
      })
      .then( (data) => {
        this.equipe = data.data
      })
      .catch( (error) => {
        console.log(data)
      })
    //
    this.axiosGetOneData({
        table: "saisons",
        table_id: this.classement.saison_id
      })
      .then( (data) => {
        this.saison = data.data
      })
      .catch( (error) => {
        console.log(data)
      })
    //
    this.axiosGetOneData({
        table: "championnats",
        table_id: this.classement.championnat_id
      })
      .then( (data) => {
        this.championnat = data.data
      })
      .catch( (error) => {

      })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classements/components/Read.vue